module.exports = __webpack_public_path__ + "img/15-3.c07e459f.png";